import React from 'react';
import { Select, Input } from 'antd';

import { FilterContent } from './style';
const { Search } = Input;

const DataFilter = ({ selectOptions, handleSelect, handleSearch }) => {
    return (
        <FilterContent>
            <Select style={{ width: 150 }} defaultValue="all" onChange={handleSelect}>
                {selectOptions.map((option, index) => (
                    <Select.Option key={index} value={option.value}>
                        {option.label}
                    </Select.Option>
                ))}
            </Select>
            <Search
                placeholder="input search text"
                onSearch={handleSearch}
                style={{ width: 200 }}
            />
        </FilterContent>
    );
}

DataFilter.defaultProps = {
    handleSearch: () => {},
    handleSelect: () => {},
    selectOptions: [{ label: 'All', value: 'all' }]
};

export default DataFilter;
